<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择部门"
      class="customer-edit"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="departments">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="查询">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="departmentNO" align="center" label="编号"/>
      <el-table-column prop="outerNO" align="center" label="外部编号"/>
      <el-table-column prop="departmentName" align="center" label="名称"/>
      <el-table-column prop="employeeName" align="center" label="部门主管"/>
      <el-table-column prop="parentName" align="center" label="上级部门"/>
      <el-table-column prop="fax" align="center" label="传真"/>
      <el-table-column prop="telephone" align="center" label="电话"/>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";


  export default {
    name:"DepartmentSelect",
    components: {VmTable,VmSearch},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        filter: {
          parentId: "",
          filter: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
